import { Fragment, jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { withDefaultAriaLabel } from "@/aria";
import { cx } from "@/lib/cx";
import { RuiIconCalendar } from "@/lib/icons";
import { RuiCalendar } from "../calendar";
import "./date-field.script";
export function RuiDateFieldControl({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    class: cx("rui-date-field", className),
    children: /* @__PURE__ */jsx("div", {
      class: "rui-date-field__group",
      children
    })
  });
}
export function RuiDateFieldInput({
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("input", {
    ...props,
    type: "text",
    "data-date-field-input": true,
    "data-rui-control": true,
    "data-rui-control-type": "text",
    class: cx("rui-date-field__input", className),
    autocomplete: "off"
  });
}
export function RuiDateFieldToggle({
  children,
  class: className,
  aria,
  ...props
}) {
  return /* @__PURE__ */jsx("button", {
    ...props,
    aria: withDefaultAriaLabel(aria, "Open calendar"),
    type: "button",
    "data-ref": "trigger",
    "data-date-field-trigger": true,
    class: cx("rui-control-toggle", className),
    "aria-haspopup": "dialog",
    children: children ?? /* @__PURE__ */jsx(RuiIconCalendar, {})
  });
}
export function RuiDateFieldPopover({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    "data-ref": "popover",
    "data-date-field-popover": true,
    class: cx("rui-date-field__popover rui-popover rui-floating", className),
    hidden: true,
    role: "dialog",
    children
  });
}
export function RuiDateFieldCalendar(props) {
  return /* @__PURE__ */jsx(RuiCalendar, {
    ...props,
    "data-date-field-calendar": true
  });
}
export function RuiDateField({
  children,
  ...props
}) {
  return /* @__PURE__ */jsx("rui-date-field", {
    ...props,
    children: children ?? /* @__PURE__ */jsxs(Fragment, {
      children: [/* @__PURE__ */jsxs(RuiDateFieldControl, {
        children: [/* @__PURE__ */jsx(RuiDateFieldInput, {}), /* @__PURE__ */jsx(RuiDateFieldToggle, {})]
      }), /* @__PURE__ */jsx(RuiDateFieldPopover, {
        children: /* @__PURE__ */jsx(RuiDateFieldCalendar, {})
      })]
    })
  });
}